import {
    GET_COUNTRY_STATE_DEFINITIONS,
    GET_COUNTRY_STATE_DEFINITIONS_SUCCESS,
    ADD_COUNTRY_STATE_DEFINITION,
    ADD_COUNTRY_STATE_DEFINITION_SUCCESS,
    UPDATE_COUNTRY_STATE_DEFINITION,
    UPDATE_COUNTRY_STATE_DEFINITION_SUCCESS,
    DELETE_COUNTRY_STATE_DEFINITION,
    DELETE_COUNTRY_STATE_DEFINITION_SUCCESS,
    API_ERROR
  
  } from "./actionTypes"
  
  
  
  
  export const getCountryStateDefinition = () => ({
    type: GET_COUNTRY_STATE_DEFINITIONS,
  })
  
  export const getCountryStateDefinitionSuccess = record => ({
    type: GET_COUNTRY_STATE_DEFINITIONS_SUCCESS,
    payload: record,
  })
  
  export const addCountryStateDefinition = record => ({
    type: ADD_COUNTRY_STATE_DEFINITION,
    payload: record,
  })
  
  export const addCountryStateDefinitionSuccess = record => ({
    type: ADD_COUNTRY_STATE_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const updateCountryStateDefinition = record => ({
    type: UPDATE_COUNTRY_STATE_DEFINITION,
    payload: record,
  })
  
  export const updateCountryStateDefinitionSuccess = record => ({
    type: UPDATE_COUNTRY_STATE_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const deleteCountryStateDefinition = guid => ({
    type: DELETE_COUNTRY_STATE_DEFINITION,
    payload: guid,
  })
  
  export const deleteCountryStateDefinitionSuccess = guid => ({
    type: DELETE_COUNTRY_STATE_DEFINITION_SUCCESS,
    payload: guid,
  })
  
  export const countryStateError = error => {
    return {
      type: API_ERROR,
      payload: error,
    }
  }
  
  